export const isUrlSafeString = (s, allowPaddedSpaces=false) => {
    if (allowPaddedSpaces) return /^[^&$+,:;=?@#\s<>[\]{}/|\\^%]([^&$+,:;=?@#\s<>[\]{}/|\\^%]| +[^&$+,:;=?@#\s<>[\]{}/|\\^%])*$/.test(s)
    return !/([&$+,:;=?@#\s<>[\]{}/|\\^%])+/.test(s)
}